"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import ArrowLinkButtonMob from "../ui/ArrowLinkButtonMob";
import FundManagerList from "../ui/FundManagerList";
import ArrowLinkButtonDesk from "../ui/ArrowLinkButtonDesk";
import SectionHeading from "../others/SectionHeading";
import { Scheme } from "@/type/schemeType";
import { formatDate } from "@/utils/commonFunctions";

type description = {
  fundSlug: string;
  msoCode: string;
  data: Scheme;
};

export default function FundDescription({ fundSlug, msoCode, data }: description) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <section>
        <div className="flex items-center gap-3 mb-2 sm:mb-4">
          <SectionHeading heading={`About This Fund`} />

          <ArrowLinkButtonDesk href={`/mutual-fund/${fundSlug}/investment-details/${msoCode}`} text="More Information" ariaLable="Send to the page for more information" />
        </div>

        <div className="bg-white border border-[#E9E9EB] rounded-4xl p-5 xs:p-6">
          <motion.div initial={false} animate={{ height: expanded ? "auto" : 44 }} transition={{ duration: 0.3, ease: "easeInOut" }} className="overflow-hidden">
            <div className="space-y-3">
              <p className="text-sm sm:text-2sm leading-relaxed">
                <strong>{data.scheme_name}</strong> is a scheme launched by {data.amc} Mutual Fund on {formatDate(data.launch_date || "")}, and falls under the {data.cat_name} fund category. It currently manages an AUM of Rs {Number(data.asset_size_cr).toLocaleString("en-IN")} crore. The fund permits investments with a minimum SIP of Rs {data.minimum_sip_invest} and a lump sum of Rs {data.minimum_investment}. It charges an expense ratio of {data.expense_ratio}% for managing the portfolio.
              </p>
              <ul className="space-y-3">
                {data.investment_obj && (
                  <li>
                    <div className="text-2sm sm:text-base font-semibold">Investing Strategy:</div>
                    <p className="text-sm sm:text-2sm leading-relaxed">{data.investment_obj}</p>
                  </li>
                )}

                <li>
                  <div className="text-2sm sm:text-base font-semibold">Performance:</div>
                  <p className="text-sm sm:text-2sm leading-relaxed">
                    {data.scheme_name} trailing returns over different times are {data.sr_one_year_abs ?? "NA"}% (1 year), {data.sr_three_year ?? "NA"}% (3 year) and {data.sr_five_year ?? "NA"}% (5 year). The average annual return of this fund stands at {data.sr_annual_return ?? "NA"}%.
                  </p>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Toggle button */}
          <div className="mt-1">
            <button onClick={() => setExpanded(!expanded)} className="text-blue-600 text-sm font-medium hover:underline transition">
              {expanded ? "Show less" : "Show more"}
            </button>
          </div>
          <FundManagerList managerId={data.manager_id} showDetails={false} />
        </div>

        <ArrowLinkButtonMob href={`/mutual-fund/${fundSlug}/investment-details/${msoCode}`} text="More Information" ariaLable="Send to the page for more information" className="mt-5" />
      </section>
    </>
  );
}
